
import { updateStepCost as updateStepCostDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type StepCostProps = {
    description?: string;
    costID?: number,
    costType?: string;
    variantType?: string;
    issueType?: string;
    fromActivity?: string;
    toActivity?: string;
    mode?: string;
    type?: string;
    cost?: number;
    attribute?: string;
    reductionType?: string, 
    reductionPercentage?: number,
    reductionCost?: number,
    reductionDuration?: number,
    reductionValue?: string
}

export const updateStepCost = ({
    description,
    costID,
    costType,
    variantType,
    issueType,
    fromActivity,
    toActivity,
    mode,
    type,
    cost,
    attribute,
    reductionType,
    reductionPercentage,
    reductionCost,
    reductionDuration,
    reductionValue

}: StepCostProps) => {
    updateStepCostDiagram({
    description,
    costID,
    costType,
    variantType,
    issueType,
    fromActivity,
    toActivity,
    mode,
    type,
    cost,
    attribute,
    reductionType,
    reductionPercentage,
    reductionCost,
    reductionDuration,
    reductionValue})
};
